const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const getApiUrl = (endpoint) => {
  // Ensure endpoint starts with /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${normalizedEndpoint}`;
};

export const getWebSocketUrl = (endpoint) => {
  // Convert http(s) to ws(s)
  const wsBase = API_BASE_URL.replace(/^http/, 'ws');
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${wsBase}${normalizedEndpoint}`;
};

export default API_BASE_URL;
